import { render } from "./NoticeDetail.vue?vue&type=template&id=37b640e2&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=37b640e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b640e2"]])

export default __exports__